import React from "react";
import { Navbar, Nav, NavDropdown, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header id="header">
      <div className="main-nav d-block">
        <Navbar expand="lg" className="navbar-light">
          <Container fluid="xxl">
            <Navbar.Brand
              as={Link}
              to="/"
              className="d-flex align-items-center gap-2 nav-log w-fit"
            >
              <div className="navbar-brand">
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={require("../assets/images/logo.png")}
                  alt="logo"
                />
              </div>
              <h2>AI2DEV</h2>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="navbarSupportedContent" />
            <Navbar.Collapse
              id="navbarSupportedContent"
              className="py-md-0 py-3"
            >
              <Nav className="mx-auto mb-2 mb-lg-0 gap-md-3 gap-0">
                <Nav.Item>
                  <Nav.Link as={Link} to="/">
                    Home
                  </Nav.Link>{" "}
                  {/* Use as={Link} */}
                </Nav.Item>

                <NavDropdown title="Products" id="products-dropdown">
                  <NavDropdown.Item as={Link} to="/cluster">
                    Create Cluster
                  </NavDropdown.Item>{" "}
                  {/* Use as={Link} */}
                  <NavDropdown.Item as={Link} to="/deployment">
                    Deploy Application
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/listapplications">
                    Manage Application
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/project">
                    Develop solution (code)
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Migration" id="migration-dropdown">
                 
                  <NavDropdown.Item as={Link} to="/migrate">
                    Migrate MuleSoft Apps and APIs
                  </NavDropdown.Item>
                </NavDropdown>

                <Nav.Item>
                  <Nav.Link as={Link} to="/blogs">
                    Blog
                  </Nav.Link>{" "}
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/about-us">
                    About
                  </Nav.Link>{" "}
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/contact">
                    Contact Us
                  </Nav.Link>{" "}
                </Nav.Item>
              </Nav>

              {/* Log in and Create Account Buttons */}
              <div className="d-flex gap-4 cabtn">
                <Link to="/login" className="btn btn-link">
                  Log in
                </Link>
                <Link to="/createaccount" className="btn btn-link">
                  Create Account
                </Link>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
}

export default Header;
